const stats = [
  { value: "50+", label: "Projects Delivered", color: "eco-green" },
  { value: "500+", label: "Vehicles Deployed", color: "sky-blue" },
  { value: "6", label: "Contracts", color: "primary" },
  { value: "100%", label: "Client Retention", color: "purple" },
];

const colorMap: Record<string, { bg: string; text: string; border: string; glow: string }> = {
  "eco-green": {
    bg: "from-eco-green/20 to-eco-green/5",
    text: "text-eco-green",
    border: "border-eco-green/30",
    glow: "bg-eco-green/20",
  },
  "sky-blue": {
    bg: "from-sky-blue/20 to-sky-blue/5",
    text: "text-sky-blue",
    border: "border-sky-blue/30",
    glow: "bg-sky-blue/20",
  },
  "primary": {
    bg: "from-primary/20 to-primary/5",
    text: "text-primary",
    border: "border-primary/30",
    glow: "bg-primary/20",
  },
  "purple": {
    bg: "from-purple/20 to-purple/5",
    text: "text-purple",
    border: "border-purple/30",
    glow: "bg-purple/20",
  },
};

const ProjectStats = () => {
  return (
    <section className="py-12 relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-r from-eco-green/5 via-primary/5 to-sky-blue/5" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {stats.map((stat, index) => {
            const colors = colorMap[stat.color];
            return (
              <div 
                key={index} 
                className={`group relative text-center p-6 rounded-2xl bg-gradient-to-br ${colors.bg} border ${colors.border} backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg overflow-hidden`}
              >
                {/* Glow effect on hover */}
                <div className={`absolute -top-10 -right-10 w-20 h-20 rounded-full ${colors.glow} blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                
                <div className={`text-3xl md:text-4xl font-bold ${colors.text} mb-1 relative z-10`}>
                  {stat.value}
                </div>
                <div className="text-sm text-muted-foreground relative z-10">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProjectStats;
